import { IconButton } from '@repo/foundations';
import { useCallback } from 'react';
import { uploadFilesAsAttachments } from '../../../components/AIAssistant/utils';
import type { AiChatStore } from '../store';

export function AttachmentButton({ store }: { store: AiChatStore }) {
	const handleAttachmentSelection = useCallback(() => {
		const input = document.createElement('input');
		input.type = 'file';
		input.multiple = true;
		input.onchange = async (e: Event) => {
			try {
				store.setIsUploading(true);

				const { files } = e.target as HTMLInputElement;
				if (files?.length) {
					await uploadFilesAsAttachments([...files], store);
				}
			} finally {
				store.setIsUploading(false);
			}
		};
		input.click();
	}, [store]);

	return (
		<IconButton
			iconName="paperclip"
			variant="tertiary"
			onClick={handleAttachmentSelection}
			loading={store.isUploading}
			disabled={store.isUploading}
			tooltip="Attach files"
			tooltipProps={{
				offset: 8,
				position: 'top',
			}}
			data-testid="attach-files-button"
		/>
	);
}
